export default {
  NEWS_LOAD: 'NEWS_LOAD',
  NEWS_MENU_ITEM_LOAD: 'NEWS_MENU_ITEM_LOAD',
  NEWS_MENU_ITEM_COMPLETE: 'NEWS_MENU_ITEM_COMPLETE',
};


// WEBPACK FOOTER //
// ./modules/news/constants/NewsConstants.js